import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import NotificationWithIcon from '../../../../components/NotificationWithIcon';
import LaboratoryNotificationDescription from './LaboratoryNotificationDescription';
import Logger from '../../../../utils/Logger';
import OTButton from '../../../../components/tag/OTButton';
import OTButtonGroup from '../../../../components/tag/OTButtonGroup';
import Span from '../../../../components/tag/Span';
import Row from '../../../../components/tag/Row';
import { doRequestDismissNotifications } from '../../../../data/notification/actions';
import { connect } from 'react-redux';
import { laboratoryNotificationIdFromEvent } from '../../data/selector';
import ExpandHOC from '../../../../components/ExpandHOC';
import { getLogo } from '../../../../utils/LogoUtils';
import {getDepartmentDisplay} from "../../../../utils/TimelineUtils";

let { id: module_id } = module;
const logger = new Logger(module_id);

class LaboratoryNotification extends React.Component {
  render() {
    let { data, doRequestDismissNotifications, intl } = this.props;

    let unitLogo = null;
    /* Sydänsairaala logo is displayed based on organisation id 22773 */
    /*if (data.organisation === '22773') {
      let logoAttr = getLogo('SYDAN');
      unitLogo = (
        <img
          className="ot-notification__logo"
          alt={intl.formatMessage({ id: logoAttr.altTextId })}
          src={logoAttr.logoSrc}
        />
      );
    }*/

    let buttons = [
      <OTButton
        key="OK"
        disabled={data.notification.isFetching}
        onClick={() => {
          doRequestDismissNotifications([
            laboratoryNotificationIdFromEvent(data),
          ]);
        }}
      >
        <FormattedMessage id="show.info" />
      </OTButton>,
    ];

    let Description = ExpandHOC((props) => {
      let { data, isOpen, maxHeight, toggleOpen, setRef } = props;
      let style = {};
      if (isOpen) {
        style.maxHeight = maxHeight || 0;
      }
      return (
          <>
              <span className="notification-info">
                <FormattedMessage
                    id={'fimlab.description'}
                    values={{
                      organisationUnit: getDepartmentDisplay(data.organisationUnit),
                      p: (chunks) => <p>{chunks}</p>,
                      br: <br/>,
                    }}
                />
              </span>
            {/*<LaboratoryNotificationDescription
            setRef={setRef}
            isOpen={isOpen}
            style={style}
            isNotification={true}
            {...data}
          />
          <Row>
            <Span>
              <button
                className="notification-expand-toggler-button"
                onClick={toggleOpen}
              >
                {isOpen ? (
                  <span className="notification-expand-toggler">
                    <i className="notification-expand-toggler__icon icon-angle-up" />
                    <span className="notification-expand-toggler__text">
                      <FormattedMessage id="show.less" />
                    </span>
                  </span>
                ) : (
                  <span className="notification-expand-toggler expanded">
                    <i className="notification-expand-toggler__icon icon-angle-down" />
                    <span className="notification-expand-toggler__text">
                      <FormattedMessage id="show.more" />
                    </span>
                  </span>
                )}
              </button>
            </Span>
          </Row>*/}
          </>
      );
    });

    return (
        <NotificationWithIcon
            titleIntl={{id: `${module_id}.title`}}
            icon={{type: 'fa', name: 'icon-calendar'}}
            logo={unitLogo}
            dateString={data.timeOfRequest}
            description={
              <Description
                  data={data}
                  requestedCollectionDate={data.requestedCollectionDate.date}
              />
            }
        actions={
          <div className="row-fluid">
            <Span len="3" sm-len="12" style={{ marginBottom: '10px' }}>
              <OTButtonGroup fullWidth={true} type="big" expectedCount={1}>
                {buttons}
              </OTButtonGroup>
            </Span>
            <Span len="3" sm-len="0"></Span>
            <Span len="6" sm-len="12">
              {unitLogo}
            </Span>
          </div>
        }
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    doRequestDismissNotifications: (identities) =>
      dispatch(doRequestDismissNotifications(identities)),
  };
};

export default connect(
  () => ({}),
  mapDispatchToProps
)(injectIntl(LaboratoryNotification));
